import { render, staticRenderFns } from "./ztp-templates.vue?vue&type=template&id=27081e56&scoped=true"
import script from "./ztp-templates.vue?vue&type=script&lang=ts"
export * from "./ztp-templates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27081e56",
  null
  
)

export default component.exports